"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonsComponentsRefsStore = exports.ValidComponentsRefsIds = void 0;
exports.ValidComponentsRefsIds = {
    TOPBAR: 'TOPBAR',
    TABBAR: 'TABBAR',
    FOOTER: 'FOOTER',
};
class CommonsComponentsRefsStore {
    constructor() {
        this.components = new Map();
    }
    static getInstance() {
        if (!CommonsComponentsRefsStore.instance) {
            const namespaceParts = CommonsComponentsRefsStore.NAMESPACE.split('.');
            let currentNamespace = window;
            for (const part of namespaceParts) {
                if (!currentNamespace[part]) {
                    currentNamespace[part] = {};
                }
                currentNamespace = currentNamespace[part];
            }
            if (!currentNamespace.instance) {
                currentNamespace.instance = new CommonsComponentsRefsStore();
            }
            CommonsComponentsRefsStore.instance = currentNamespace.instance;
        }
        return CommonsComponentsRefsStore.instance;
    }
    addComponent(type, ref) {
        this.components.set(type, ref);
    }
    getComponent(type) {
        return this.components.get(type);
    }
    removeComponent(type) {
        this.components.delete(type);
    }
}
CommonsComponentsRefsStore.NAMESPACE = 'ods.utils.CommonsComponentsRefsStoreInstance';
exports.CommonsComponentsRefsStore = CommonsComponentsRefsStore;
//# sourceMappingURL=CommonsComponentsRefsStore.js.map